export class CvField {
  constructor(public exclude = false) { }
}
